import { FC, useContext, useEffect, useRef, useState } from "react";
import { useAppDispatch } from "hooks";
import { setPageTitle, setPageType } from "store";
import { PageType } from "types";
import styles from "./styles.module.scss";
import ImageUploading, { ImageListType } from "react-images-uploading";
import { Button } from "@progress/kendo-react-buttons";
import {
  DropDownList,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
import {
  Card,
  CardBody,
  CardHeader,
  CardImage,
  CardTitle,
} from "@progress/kendo-react-layout";
import Slider from "react-slick";
import { Loader } from "@progress/kendo-react-indicators";
import {
  TextArea,
  Slider as KendoSlider,
  TextAreaHandle,
} from "@progress/kendo-react-inputs";
import { PDFExport } from "@progress/kendo-react-pdf";
import { SettingsContext } from "context";
import { Error } from "@progress/kendo-react-labels";
import { RadioGroup } from "@progress/kendo-react-inputs";
import { Tooltip } from "@progress/kendo-react-tooltip";
import Typewriter from "typewriter-effect";
import {
  CONTOSO_COPILOT_DEMOS,
  CONTOSO_COPILOT_PROD,
  CONTOSO_COPILOT_PROD_HARDCODED,
  DEMOS,
  FSI_DEMOS,
  MFG_FABRIC_DEMO,
} from "common";
declare var $: any;
const DROPDOWN_OPTIONS = [
  {
    label: "Refined Simplicity Collection",
    value: "https://i.ibb.co/SvSp7F7/minimalist.png",
    emailDescription: `Write an email advertisement for a company called Contoso. The email is for a promotion for a 50% discount on the launch of a new line of clothing. The new line focuses on minimalism. The email should include the following:\n1. A subject line for the email.\n2. Choose words that communicate minimalism.\n3. A poem about how the line of clothing demonstrates minimalism.\n4. Include appropriate emojis in the email.\n5. Include relevant Hashtags.\n6. Email should contain at least 40 words.\nConsidering everything described above, give me an email with a title, content with appropriate hashtags and emojis. Close the email with a relevant poem as described above and proper greeting.`,
    instaDescription: `Write an Instagram post for a company called Contoso. The post is for a promotion for a 50% discount on the launch of a new line of clothing. The new line focuses on minimalism. The post should include the following:\n1. A headline for the Instagram post.\n2. Choose words that communicate minimalism.\n3. A poem about how the line of clothing demonstrates minimalism.\n4. Include appropriate emojis in the post.\n5. Include relevant Hashtags.\n6. Post should contain at least 40 words.\nConsidering everything described above, give me an Instagram post with a post title, post content with appropriate hashtags and emojis. Close the post with a relevant poem as described above.`,
    number: "1",
  },
  {
    label: "Sports Car",
    value:
      "https://dreamdemoassets.blob.core.windows.net/openai/orange_sports_car.png",
    emailDescription: `Write an email advertisement for a company called Contoso. The email is a promotional email for the launch of their new sports car. The new sports car is defined by its speed and lower carbon footprint as it runs on natural gas. The post should include the following:\n1. A subject line for the email.\n2. Choose words that communicate awareness and speed.\n3. A poem about the fusion of beauty with awareness with respect to automobile\n4. Include appropriate emojis in the post.\n5. Include relevant Hashtags.\n6. Email should contain at least 40 words.\nConsidering everything described above, give me an email having a title, email content with appropriate hashtags and emojis. Close the email with a poem as described above and appropriate greetings.`,
    instaDescription: `Write an Instagram post for a company called Contoso. The post is a promotion post for the launch of their new sports car. The new sports car is defined by its speed and lower carbon footprint as it runs on natural gas. The post should include the following:\n1. A headline for the Instagram post.\n2. Choose words that communicate awareness and speed.\n3. A poem about the fusion of beauty with awareness with respect to automobiles.\n4. Include appropriate emojis in the post.\n5. Include relevant Hashtags.\n6. Post should contain at least 40 words.\nConsidering everything described above, give me an Instagram post having a title, post content with appropriate hashtags and emojis. Close the post with a poem as described above.`,
    number: "3",
  },
  {
    label: "Sustainable Elegance",
    value: "https://i.ibb.co/NYDFvrb/Earthwise-Elegance.png",
    emailDescription: `You are a marketing manager for a clothing company called Contoso. Write a promotional marketing email to a customer for the launch of their new line of sustainable clothing. The email should include the following:\n1. A Subject line for the email.\n2. Start by greeting the customer.\n3. Choose words that communicate the company's commitment to sustainability while keeping up with the latest fashion trends and elegance.\n4. Include a promotional offer of 50% discount and create a sense of urgency.\n5. Email should contain at least 35 words.`,
    instaDescription: `You are a marketing manager for a clothing company called Contoso. Write a promotional Instagram post about the launch of the company's new line of sustainable clothing. The post should include the following:\n1. Start with a tagline for the post.\n2. Post content with relevant emojis and hashtags.\n3. A poem which describes the importance of sustainable clothing options.\n4. Include a promotional offer of 50% discount and create a sense of urgency.\n5. The post should contain at least 45 words.\nWrite an Instagram post with all of the above mentioned requirements. The post should be well segmented and closed with a poem.`,
    number: "2",
  },
];

const ABSTRACT_RADIO_VALUES = [
  {
    label: "Realistic",
    value: 0,
  },
  {
    label: "Abstract ",
    value: 1,
  },
];

const PROMPT_RADIO_VALUES = [
  {
    label: "Generate New Image",
    value: 0,
  },
  {
    label: "Change Background",
    value: 1,
  },
];

const PROMPTS = [
  `Removing image background using Azure Computer Vision...\n`,
  `Extracting dense captions using Computer Vision and Florence-based AI models...\n`,
  `Extracting colors present in the image using Azure ChatGPT and Python Imaging Library...\n`,
  `Generating an image using DALL-E 2 in Azure OpenAI Service...\n`,
  `Summarizing the extracted captions using Azure ChatGPT...\n`,
  `Merging the Dall-E2 generated background with the background removed image using the Python Imaging library...`,
];

interface Dropdown {
  label: string;
  value: string;
  emailDescription: string;
  number: string;
  instaDescription: string;
  bgPrompt?: string;
}

export const SocialMediaCampaign: FC = () => {
  const container = useRef<PDFExport>(null);
  const [dropdownOptions, setDropdownOptions] = useState<Dropdown[]>([]);
  const dispatch = useAppDispatch();
  const [images, setImages] = useState<ImageListType>([]);
  const [imageDescription, setImageDescription] = useState(
    dropdownOptions?.[0]?.emailDescription
  );
  const [prompt, setPrompt] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isImageLoading, setIsImageLoading] = useState(false);
  const [dalleImages, setDalleImages] = useState<string[]>([]);
  const [consistencyFactor, setConsistencyFactor] = useState(0.8);
  const [showCaptions, setShowCaptions] = useState(false);
  const [showPrompt, setShowPrompt] = useState(false);
  const [selectedImage, setSelectedImage] = useState(0);
  const [recommendedResult, setRecommendedResult] = useState<any>();
  const [campaign, setCampaign] = useState("");
  const { currentDemo, industry } = useContext(SettingsContext);
  const [isError, setIsError] = useState<any>("");
  const [isAdError, setIsAdError] = useState<any>("");
  const [isEdit, setIsEdit] = useState(false);
  const [isPromptEdit, setIsPromptEdit] = useState(false);
  const [isPromptUpdated, setIsPromptUpdated] = useState(false);
  // const [isAbstract, setIsAbstract] = useState(1);
  const [isBackgroundChange, setIsBackgroundChange] = useState(1);
  const handlePromptRadio = (e: any) => {
    setIsBackgroundChange(e.value);
  };

  const CAMPAIGN_OPTIONS = [
    {
      label: "Instagram Campaign",
      value: "instagram",
    },
    {
      label: "Email Campaign",
      value: "email",
    },
  ];

  // const handleAbstract = (e: any) => {
  //   setIsAbstract(e.value);
  // };

  useEffect(() => {
    dispatch(setPageType(PageType.SocialMediaCampaign));
    dispatch(setPageTitle("Florence Model"));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (currentDemo?.campaigns.length > 0) {
      const mappedCampaigns = currentDemo.campaigns.map((c: any) => ({
        label: c.name,
        value: c.imageUrl,
        number: c.order,
        instaDescription: c.instagramText,
        emailDescription: c.emailText,
        bgPrompt: c.bgPrompt,
      }));

      setDropdownOptions(mappedCampaigns);
      setValue(mappedCampaigns[0]);
    }
  }, [currentDemo]);

  const [result, setResult] = useState<any>({});

  const onChange = (imageList: ImageListType) => {
    setResult({});
    setDalleImages([]);
    setIsProcessing(false);
    setImages(imageList as never[]);
    setImageDescription("");
  };

  const getUpdatedImages = () => {
    setShowCaptions(false);
    setShowPrompt(false);
    setDalleImages([]);
    setIsImageLoading(true);
    const formData: any = new FormData();
    // if (images.length) {
    //   const fileData = images[0].file;
    //   formData.append("dalle_prompt", prompt);
    //   // formData.append("guid", currentDemo?.guid);
    //   // if (isBackgroundChange)
    //   //   formData.append(
    //   //     "bg_removed_url",
    //   //     recommendedResult?.background_removed_image
    //   //   );
    //   // formData.append("is_abstract", !!isAbstract);
    //   // formData.append("number", 3);
    //   // formData.append("prompt", recommendImageDescription);
    // }
    setIsError("");
    fetch(
      currentDemo?.guid === MFG_FABRIC_DEMO
        ? "https://func-florence-openai-dev001.azurewebsites.net/api/regenerate-dalle"
        : CONTOSO_COPILOT_DEMOS.includes(currentDemo?.guid) ||
          FSI_DEMOS.includes(currentDemo?.guid)
        ? "https://func-florence-openai-dev001.azurewebsites.net/api/regenerate-dalle"
        : industry?.dalleRegenerateAPI ??
          "https://func-openai-florence-dev005.azurewebsites.net/api/Regenerate_Dalle",
      {
        method: "post",
        body: JSON.stringify({
          guid: currentDemo?.guid,
          dalle_prompt: prompt,
          ...(currentDemo.guid !== MFG_FABRIC_DEMO &&
            isBackgroundChange && {
              bg_removed_url: recommendedResult?.background_removed_image,
            }),
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setRecommendedResult((old: any) => ({
          ...old,
          recommendedItems: res?.recommendedItems,
          prompt: res?.dalle_prompt,
        }));
        setPrompt(res?.dalle_prompt);
        setDalleImages(Object.values(res.recommendedItems));
      })
      .catch((e) => {
        console.log(e);
        setIsError(e);
      })
      .finally(() => setIsImageLoading(false));
  };

  const getRecommendedProducts = () => {
    setIsPromptUpdated(false);
    setShowCaptions(false);
    setShowPrompt(false);
    setDalleImages([]);
    setIsImageLoading(true);
    const formData: any = new FormData();
    if (images.length) {
      const fileData = images[0].file;
      formData.append("image", fileData);
      formData.append("guid", currentDemo?.guid);
      // formData.append("is_abstract", !!isAbstract);
      // formData.append("number", 3);
      // formData.append("prompt", recommendImageDescription);
    }
    setIsError("");
    fetch(
      images.length > 0 && CONTOSO_COPILOT_PROD === currentDemo?.guid
        ? "https://func-campaigngeneration-image-uat.azurewebsites.net/api/Generate_Images"
        : MFG_FABRIC_DEMO === currentDemo?.guid
        ? "https://func-recommend-images.azurewebsites.net/api/recommendimages"
        : CONTOSO_COPILOT_DEMOS.includes(currentDemo?.guid)
        ? "https://func-recommend-images.azurewebsites.net/api/recommendimages"
        : FSI_DEMOS.includes(currentDemo?.guid)
        ? "https://func-openai-florence-dev001.azurewebsites.net/api/recommendfromimage_v2"
        : industry?.florenceDallEApi ??
          "https://func-openai-florence-dev005.azurewebsites.net/api/Generate_Images",
      {
        method: "post",
        body: images.length
          ? formData
          : JSON.stringify({
              image_url: value?.value,
              guid: currentDemo?.guid,
              ...(FSI_DEMOS.includes(currentDemo?.guid) &&
              value?.number.toString() === "2"
                ? {
                    image_num: "3",
                  }
                : (CONTOSO_COPILOT_DEMOS.includes(currentDemo?.guid) ||
                    MFG_FABRIC_DEMO === currentDemo?.guid) &&
                  value?.number.toString() === "1"
                ? {
                    image_num: "3",
                  }
                : {
                    bg_prompt: value?.bgPrompt,
                  }),
              // is_abstract: !!isAbstract,
              // image_num: value.number,
            }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (res?.message) {
          setIsError(res);
        }
        setRecommendedResult(res);
        setPrompt(res?.prompt);
        setDalleImages(Object.values(res.recommendedItems));
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => setIsImageLoading(false));
  };

  const exportPDFWithComponent = () => {
    if (container.current) {
      container.current.save();
    }
  };

  const fetchData = (formData?: any) => {
    getRecommendedProducts();
    setIsLoading(true);
    setIsAdError("");
    setDalleImages([]);
    fetch(
      currentDemo?.guid === CONTOSO_COPILOT_PROD_HARDCODED
        ? "https://func-campaigngeneration-hardcoded.azurewebsites.net/api/campaigngeneration?"
        : industry?.florenceAdApi ??
            "https://backupclientfunction.azurewebsites.net/api/campaigngenerationv3",
      {
        method: "post",
        ...(formData && { body: formData }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setCampaign(res.campaign);
        setResult(res);
      })
      .catch((e) => {
        console.log(e);
        setIsAdError(e);
      })
      .finally(() => setIsLoading(false));
  };

  const [value, setValue] = useState<Dropdown>(dropdownOptions?.[0]);
  const [campaignType, setCampaignType] = useState<{
    label: string;
    value: string;
  }>(CAMPAIGN_OPTIONS[0]);

  const [isProcessing, setIsProcessing] = useState(false);

  const handleChange = (event: DropDownListChangeEvent) => {
    setImages([]);
    setPrompt("");
    setIsError("");
    setIsAdError("");
    setIsPromptUpdated(false);
    const filteredValue = dropdownOptions?.filter(
      (d) => d.label === event.target.value
    )[0];
    setIsProcessing(false);
    setValue(filteredValue);
    setDalleImages([]);
    setImageDescription(
      campaignType.value === "email"
        ? filteredValue.emailDescription
        : filteredValue.instaDescription
    );
  };

  const handleCampaignChange = (event: DropDownListChangeEvent) => {
    setImages([]);
    const filteredValue = CAMPAIGN_OPTIONS.filter(
      (d) => d.label === event.target.value
    )[0];
    setIsProcessing(false);
    setCampaignType(filteredValue);
    setImageDescription(
      campaignType.value === "email"
        ? value?.emailDescription
        : value?.instaDescription
    );
    setDalleImages([]);
    setIsError("");
    setIsAdError("");
  };

  useEffect(() => {
    if (value)
      setImageDescription(
        campaignType.value === "email"
          ? value?.emailDescription
          : value?.instaDescription
      );
  }, [campaignType.value, value]);

  const onProcess = () => {
    setDalleImages([]);
    setIsError("");
    setIsAdError("");
    setIsProcessing(true);
    setPrompt("");
    setResult({});
    setIsPromptUpdated(false);
    if (images?.length) {
      const formData: any = new FormData();
      const fileData = images[0].file;
      formData.append("image", fileData);
      formData.append("description", imageDescription);
      formData.append("type", campaignType.value);
      formData.append("creative_factor", consistencyFactor.toString());
      formData.append("guid", currentDemo?.guid);
      // formData.append("is_abstract", !!isAbstract);
      fetchData(formData);
    } else {
      fetchData(
        JSON.stringify({
          guid: currentDemo?.guid,
          description: imageDescription,
          type: campaignType.value,
          creative_factor: consistencyFactor.toString(),
        })
      );
    }
  };

  //preload images
  function preloadImage(src: string) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = function () {
        resolve(img);
      };
      img.onerror = img.onabort = function () {
        reject(src);
      };
      img.src = src;
    });
  }

  useEffect(() => {
    let isCancelled = false;

    async function effect() {
      if (isCancelled) {
        return;
      }

      const imagesPromiseList: Promise<any>[] = [];
      for (const i of dropdownOptions) {
        imagesPromiseList.push(preloadImage(i.value));
      }

      await Promise.all(imagesPromiseList);

      if (isCancelled) {
        return;
      }
    }

    effect();

    return () => {
      isCancelled = true;
    };
  }, []);

  const campaignTextAreaRef = useRef<TextAreaHandle | null>(null);

  useEffect(() => {
    isEdit && campaignTextAreaRef.current?.focus();
  }, [isEdit]);

  const promptTextAreaRef = useRef<TextAreaHandle | null>(null);

  useEffect(() => {
    isPromptEdit && promptTextAreaRef.current?.focus();
  }, [isPromptEdit]);

  return (
    <div className={styles.container}>
      <div className={styles.tabContainer}>
        <div className={styles.tabImg}>
          <ImageUploading
            value={images}
            onChange={onChange}
            allowNonImageType={false}
            multiple={false}
          >
            {({ imageList, onImageUpload, onImageRemoveAll }) => {
              return (
                <div
                  className={`upload__image-wrapper ${styles.imageWrapper}`}
                  style={{ width: "100%" }}
                >
                  {!imageList?.length && dropdownOptions?.length > 0 && (
                    <DropDownList
                      className={styles.dropDown}
                      data={dropdownOptions?.map((d) => d.label)}
                      value={value?.label}
                      onChange={handleChange}
                      disabled={isImageLoading || isLoading}
                    />
                  )}

                  {imageList?.length > 0 &&
                    imageList?.map((image, index) => (
                      <div
                        key={index}
                        className="image-item"
                        style={{
                          // height: 300,
                          position: "relative",
                        }}
                      >
                        <span
                          onClick={() => {
                            !isLoading && setImages([]);
                            setValue(dropdownOptions?.[0]);
                            setCampaignType(CAMPAIGN_OPTIONS[0]);
                            setImageDescription(
                              dropdownOptions?.[0]?.emailDescription
                            );
                          }}
                          className={`k-icon k-i-close ${styles.closeBtn}`}
                        ></span>
                        <img
                          src={image.dataURL}
                          alt="uploaded-img"
                          style={{ height: "100%" }}
                        />
                      </div>
                    ))}
                  {images.length === 0 && (
                    <>
                      <img src={value?.value} alt={value?.label} />
                    </>
                  )}
                  {(!DEMOS.includes(currentDemo?.guid) ||
                    currentDemo?.guid === CONTOSO_COPILOT_PROD) && (
                    <>
                      <p style={{ textAlign: "center" }}>or</p>
                      <Button
                        className={styles.btn}
                        onClick={() => onImageUpload()}
                        disabled={isImageLoading || isLoading}
                        id="#file"
                      >
                        Select File
                      </Button>
                    </>
                  )}

                  {!images.length && (
                    <>
                      <p>Campaign Type</p>
                      <DropDownList
                        className={styles.dropDown}
                        data={
                          currentDemo?.guid === MFG_FABRIC_DEMO
                            ? [CAMPAIGN_OPTIONS[0].label]
                            : CAMPAIGN_OPTIONS.map((d) => d.label)
                        }
                        value={campaignType?.label}
                        onChange={handleCampaignChange}
                        disabled={isImageLoading || isLoading}
                      />
                    </>
                  )}
                  {/* <RadioGroup
                    className={styles.radioGroup}
                    data={ABSTRACT_RADIO_VALUES}
                    onChange={handleAbstract}
                    value={isAbstract}
                    layout="horizontal"
                  /> */}
                  <p style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    Surprise Factor{" "}
                    <Tooltip
                      tooltipClassName={styles.tooltip}
                      position={"right"}
                      anchorElement="target"
                      content={(props) => (
                        <div
                          style={{
                            wordWrap: "break-word",
                            width: 200,
                            padding: 8,
                            fontSize: 13,
                          }}
                        >
                          {props.title}
                        </div>
                      )}
                    >
                      <span
                        title={`Surprise factor controls the temperature parameter which controls the randomness in output.\nChoose a high value to get more interesting content.`}
                        className="k-icon k-i-question"
                        style={{
                          color: "#0ced85",
                        }}
                      ></span>
                    </Tooltip>
                  </p>
                  <div
                    style={{
                      display: "flex",
                      color: "white",
                      gap: 8,
                      fontSize: 14,
                      alignItems: "center",
                    }}
                  >
                    Min
                    <KendoSlider
                      min={0}
                      className={styles.creativeFactor}
                      max={1}
                      value={consistencyFactor}
                      onChange={(e) =>
                        setConsistencyFactor(+e.value.toFixed(1))
                      }
                    />
                    Max
                  </div>

                  <p>Enter campaign description:</p>
                  <TextArea
                    key={value?.value}
                    value={imageDescription}
                    onChange={(e) => setImageDescription(e.value)}
                    autoSize={true}
                    placeholder="Enter campaign description"
                    className={styles.textArea}
                  />
                  <Button
                    className={styles.btn}
                    disabled={isImageLoading || isLoading}
                    onClick={onProcess}
                    id="#file"
                  >
                    Process
                  </Button>
                </div>
              );
            }}
          </ImageUploading>
        </div>

        <div className={styles.tabTextContainer}>
          <div className={styles.tabText}>
            {isProcessing ? (
              <>
                <div className={styles.textContainer}>
                  <Card className={styles.cardContainer}>
                    {!isLoading && (
                      <CardHeader>
                        <CardTitle>
                          <strong>
                            {result?.title ?? "Generated Marketing Copy"}
                          </strong>
                        </CardTitle>
                      </CardHeader>
                    )}
                    <CardBody className={styles.cardBody}>
                      <div
                        style={{
                          overflowY: "auto",
                          width: "50%",
                          display: "flex",
                          flexDirection: "column",
                          gap: 8,
                        }}
                      >
                        {isLoading ? (
                          <div
                            className={styles.loaderContainer}
                            style={{ color: "white", height: 350, width: 400 }}
                          >
                            <h2 className={styles.generatingVerbText}>
                              Generating Campaign...
                            </h2>
                            <Loader
                              style={{
                                color: "white",
                                height: 350,
                                width: 400,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            />
                          </div>
                        ) : isAdError ? (
                          <Error className={styles.error}>
                            <div>
                              <span
                                className="k-icon k-i-warning"
                                style={{ marginRight: 8 }}
                              />
                              Oops! Something went wrong. Please try again
                              later.
                            </div>
                            <p>{isAdError?.message}</p>
                            <br />
                            <Button
                              className={styles.btn}
                              style={{
                                backgroundColor: "#ffc000",
                                fontWeight: 600,
                                color: "black",
                              }}
                              onClick={() => {
                                fetchData(
                                  JSON.stringify({
                                    guid: currentDemo?.guid,
                                    description: imageDescription,
                                    type: campaignType.value,
                                    creative_factor:
                                      consistencyFactor.toString(),
                                  })
                                );
                              }}
                            >
                              Retry
                            </Button>
                          </Error>
                        ) : (
                          <>
                            <TextArea
                              value={campaign}
                              key={value?.value}
                              readOnly={!isEdit}
                              onChange={(e) => setCampaign(e.value)}
                              autoSize={true}
                              ref={campaignTextAreaRef}
                              className={`${styles.campaignTextArea} ${
                                !isEdit && styles.disableTextArea
                              }`}
                            />
                            {!isImageLoading &&
                              result &&
                              dalleImages.length > 0 && (
                                <div className={styles.btnContainer}>
                                  <Button
                                    onClick={() => setIsEdit((old) => !old)}
                                    className={styles.btn}
                                  >
                                    {isEdit ? "Save" : "Edit"}
                                  </Button>
                                  <Button
                                    className={styles.btn}
                                    onClick={() => exportPDFWithComponent()}
                                  >
                                    Print
                                  </Button>
                                </div>
                              )}
                          </>
                        )}
                      </div>
                      <div style={{ width: "50%" }}>
                        <div
                          style={{
                            position: "relative",
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "column",
                            gap: 8,
                            width: "100%",
                            height: "100%",
                          }}
                        >
                          {isImageLoading ? (
                            <div
                              style={{
                                height: "100%",
                                width: "100%",
                                display: "flex",
                                justifyContent: "flex-start",
                                flexDirection: "column",
                                whiteSpace: "break-spaces",
                              }}
                            >
                              {isPromptUpdated ? (
                                <Typewriter
                                  key={isImageLoading.toString()}
                                  onInit={(typewriter) => {
                                    typewriter.typeString(PROMPTS[3]).start();
                                  }}
                                />
                              ) : (
                                <Typewriter
                                  key={isImageLoading.toString()}
                                  options={{
                                    delay: 35,
                                  }}
                                  onInit={(typewriter) => {
                                    typewriter
                                      .typeString(PROMPTS[0])
                                      .typeString("\n")
                                      .typeString(PROMPTS[1])
                                      .typeString("\n")
                                      .typeString(PROMPTS[2])
                                      .typeString("\n")
                                      .typeString(PROMPTS[3])
                                      .typeString("\n")
                                      .typeString(PROMPTS[4])
                                      .typeString("\n")
                                      .typeString(PROMPTS[5])
                                      .start();
                                  }}
                                />
                              )}
                            </div>
                          ) : isError ? (
                            <Error className={styles.error}>
                              <div>
                                <span
                                  className="k-icon k-i-warning"
                                  style={{ marginRight: 8 }}
                                />
                                Oops! Something went wrong. Please try again
                                later.
                              </div>
                              <p>{isError?.message}</p>
                              <br />
                              <Button
                                className={styles.btn}
                                style={{
                                  backgroundColor: "#ffc000",
                                  fontWeight: 600,
                                  color: "black",
                                }}
                                onClick={() => {
                                  isPromptUpdated
                                    ? getUpdatedImages()
                                    : getRecommendedProducts();
                                }}
                              >
                                Retry
                              </Button>
                            </Error>
                          ) : (
                            <>
                              <div className={styles.btnContainer}>
                                <Button
                                  className={styles.btn}
                                  onClick={() => {
                                    setShowCaptions((old) => !old);
                                    setShowPrompt(false);
                                  }}
                                  style={{
                                    ...(showCaptions && {
                                      border: "1px solid white",
                                    }),
                                  }}
                                >
                                  {!showCaptions ? "Show" : "Hide"} Process
                                </Button>
                                {!(
                                  FSI_DEMOS.includes(currentDemo?.guid) &&
                                  value?.number.toString() !== "2"
                                ) && (
                                  <Button
                                    id="btnShowPrompt"
                                    className={styles.btn}
                                    onClick={() => {
                                      setShowPrompt((old) => !old);
                                      setShowCaptions(false);
                                    }}
                                    style={{
                                      ...(showPrompt && {
                                        border: "1px solid white",
                                      }),
                                    }}
                                  >
                                    {!showPrompt ? "Show" : "Hide"} Prompt
                                  </Button>
                                )}
                              </div>
                              {showCaptions ? (
                                <div className={styles.showCaptions}>
                                  <p>Image Background Removed: </p>
                                  <a
                                    style={{ color: "white" }}
                                    target="_blank"
                                    href={
                                      recommendedResult?.background_removed_image
                                    }
                                    rel="noreferrer"
                                  >
                                    {
                                      recommendedResult?.background_removed_image
                                    }
                                  </a>
                                  <hr />
                                  <p>Extracted Dense Captions:</p>
                                  {recommendedResult?.caption}
                                  <hr />
                                  <p>
                                    Extracted Colors:{" "}
                                    {recommendedResult?.colors}
                                  </p>
                                  <hr />
                                  <p>
                                    Dall.E 2 Prompt: {recommendedResult?.prompt}
                                  </p>
                                  <hr />
                                  <p>
                                    Generated Summary of Caption:{" "}
                                    {recommendedResult?.["summary of caption"]}
                                  </p>
                                </div>
                              ) : showPrompt ? (
                                <div
                                  className={styles.showCaptions}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 8,
                                  }}
                                >
                                  <TextArea
                                    key={value?.value}
                                    readOnly={!isPromptEdit}
                                    value={prompt}
                                    onChange={(e) => setPrompt(e.value)}
                                    autoSize={true}
                                    placeholder="Enter prompt"
                                    className={`${styles.promptTextArea} ${
                                      !isPromptEdit && styles.disableTextArea
                                    }`}
                                    ref={promptTextAreaRef}
                                  />
                                  {!DEMOS.includes(currentDemo?.guid) && (
                                    <RadioGroup
                                      className={styles.radioGroup}
                                      data={PROMPT_RADIO_VALUES}
                                      onChange={handlePromptRadio}
                                      value={isBackgroundChange}
                                      layout="horizontal"
                                      disabled={!isPromptEdit}
                                    />
                                  )}
                                  <div className={styles.btnContainer}>
                                    <Button
                                      onClick={() => {
                                        if (isPromptEdit) {
                                          getUpdatedImages();
                                          setIsPromptUpdated(true);
                                        }
                                        setIsPromptEdit((old) => !old);
                                      }}
                                      className={styles.btn}
                                    >
                                      {isPromptEdit ? "Send" : "Edit"}
                                    </Button>
                                  </div>
                                </div>
                              ) : (
                                <div
                                  style={{
                                    height: 350,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  {dalleImages?.[selectedImage] && (
                                    <img
                                      style={{
                                        height: 350,
                                        // width: 425,
                                        borderRadius: 8,
                                      }}
                                      src={dalleImages[selectedImage]}
                                      alt="img"
                                    />
                                  )}
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              </>
            ) : null}
          </div>
          {dalleImages.length > 0 && (
            <div className={styles.tabText}>
              <div className={styles.textContainer}>
                <Card className={styles.carouselCardContainer}>
                  <CardHeader>
                    <CardTitle>
                      Alternative Images
                      <span
                        onClick={() => getRecommendedProducts()}
                        className={`k-icon k-i-reset-sm ${styles.refreshIcon}`}
                      ></span>
                    </CardTitle>
                  </CardHeader>
                  <CardBody
                    style={{
                      height: 290,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Slider
                      arrows={true}
                      dots={true}
                      lazyLoad="progressive"
                      autoplay={false}
                      slidesToShow={3}
                      infinite={false}
                      className={styles.slick}
                      pauseOnFocus
                      pauseOnHover
                    >
                      {dalleImages?.map((item, index) => {
                        return (
                          <div
                            onClick={() => {
                              setSelectedImage(index);
                            }}
                            key={index}
                            className={styles.slideContainer}
                          >
                            <div
                              className={`${styles.overlay} ${
                                selectedImage === index && styles.showArrow
                              }`}
                            >
                              <span
                                className={`k-icon k-i-check-circle ${styles.checkIcon}`}
                              ></span>
                            </div>
                            <CardImage
                              style={{
                                height: 260,
                                width: 260,
                                borderRadius: 8,
                              }}
                              src={item}
                            />
                          </div>
                        );
                      })}
                    </Slider>
                  </CardBody>
                </Card>
              </div>
            </div>
          )}
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          left: -10000,
          top: 0,
        }}
      >
        <PDFExport
          paperSize="A4"
          landscape={true}
          margin="20"
          scale={1} // 1.1 for portrait
          ref={container}
          fileName={value?.label}
        >
          <div className={styles.tabText}>
            <div className={styles.textContainer}>
              <Card className={styles.cardContainer}>
                <CardHeader>
                  <CardTitle>
                    <strong>
                      {result?.title ?? "Generated Marketing Copy"}
                    </strong>
                  </CardTitle>
                </CardHeader>
                <CardBody className={styles.cardBody}>
                  <div>
                    <p style={{ whiteSpace: "break-spaces" }}>{campaign}</p>
                  </div>
                  <div>
                    <div
                      style={{
                        position: "relative",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        style={{
                          height: 350,
                          width: 425,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          style={{
                            height: 350,
                            width: 425,
                            borderRadius: 8,
                          }}
                          src={dalleImages[selectedImage]}
                          alt="img"
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>
        </PDFExport>
      </div>
    </div>
  );
};
